import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImage, faImageSlash } from '@fortawesome/pro-light-svg-icons'

import { digObject } from '@domain-group/javascript-utils'

import { Box, DashboardModuleListItem, Link } from '@domain-group/suit-theme'

import useOrderItemTask from '@hooks/useOrderItemTask'

import type { OrderItemTaskModel } from '@models/types'

const OrderItemTaskActions = (props: { orderItemTask: OrderItemTaskModel }) => {
  const { orderItemTask } = props

  const image = digObject(orderItemTask, 'instruction_image.large', '')

  const { callbacks: { createOrEditOrderItemTask } } = useOrderItemTask(orderItemTask)

  return (
    <Box justifyContent="center" alignItems="center">
      {!image && <FontAwesomeIcon color="lightGrey" icon={faImageSlash} />}

      {image && (
        <Link href={image} target="_blank">
          <FontAwesomeIcon icon={faImage} />
        </Link>
      )}

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Icon
        boxProps={{ marginLeft: 'medium' }}
        onClick={() => createOrEditOrderItemTask()}
        type="edit"
      />
    </Box>
  )
}

export default OrderItemTaskActions
